
import { LoginConsts } from 'client/util/Constants';
import { defineComponent } from 'vue';
import { mapStores } from 'pinia';
import EmailBadge from 'client/components/EmailBadge.vue';
import LoginCard from 'client/components/LoginCard.vue';
import UserLoginStore from 'client/stores/UserLoginStore';

const { mfaDirectResetNoFactors } = LoginConsts.responseMessages;

const REASON_NO_FACTORS = 'NO_FACTORS';

/**
 * Renders email vs MFA options. Parent (RequestPasswordReset) probes SI eligibility
 * first and only mounts this when reason is not ALLOW_UNENROLLED / FEATURE_DISABLED —
 * so option cards never flash for gated orgs.
 */
export default defineComponent({
  name: 'UserResetPasswordMethodSelection',

  components: {
    EmailBadge,
    LoginCard,
  },

  computed: {
    ...mapStores(UserLoginStore),

    email(): string {
      return this.userLoginStore.email || '';
    },

    eligibilityReason(): string | undefined {
      return this.userLoginStore.eligibility?.reason;
    },

    isNoFactors(): boolean {
      return this.eligibilityReason === REASON_NO_FACTORS;
    },

    isMfaDisabled(): boolean {
      return this.isNoFactors;
    },

    noFactorsMessage(): string {
      return mfaDirectResetNoFactors;
    },
  },

  methods: {
    goToLogin() {
      this.$emit('goToLogin');
    },

    selectEmail() {
      this.userLoginStore.resetPath = 'email';
      this.$emit('selectEmail');
    },

    selectMfa() {
      // Anti-enumeration: non-existent emails return eligible:false with no reason —
      // both options stay navigable. Only NO_FACTORS disables MFA.
      if (this.isMfaDisabled) {
        return;
      }

      this.userLoginStore.resetPath = 'mfa-direct';
      // Parent routes with SSO/oauth context + redirectTo preserved
      this.$emit('selectMfa');
    },
  },
});
